// Imported FIRST by main.jsx so Sentry is ready before the app module graph evaluates.
// No-op unless EXPO_PUBLIC_SENTRY_DSN is set (same DSN/project as mobile; filter with service:vibelink-web).
import * as Sentry from "@sentry/react";

const dsn = import.meta.env.EXPO_PUBLIC_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    initialScope: { tags: { service: "vibelink-web" } },
  });
}
